import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from './logger.service';
import { BehaviorSubject } from 'rxjs';
import { SearchItemIdDialogComponent } from 'src/app/components/search-item-id-dialog/search-item-id-dialog.component';
import { BillPaymentSearchItemPackageDialogComponent } from 'src/app/components/bill-payment-search-item-package-dialog/bill-payment-search-item-package-dialog.component';
import { SearchGRNMedDialogComponent } from 'src/app/components/search-grnmed-dialog/search-grnmed-dialog.component';




const TAG = 'SearchItemIDDialogService';

@Injectable({
    providedIn: 'root'
})
export class SearchItemIDDialogService {

    static Filter_Search_Service_Only = 1;
    static Filter_Search_Item_Only = 2;
    static Filter_Search_All = 3;
    static Filter_search_30=5;
    static Filter_Search_NonDiagonsis_Service_Only  = 4;


    constructor(private log: LoggerService,
        private modalService: NgbModal
    ) { }

    openDialog(action: string, tableKeyValue: string, status: string, msg: string) {
        // console.log('open Dialog');
        this.log.d(TAG, 'open Dialog ,action = ' + action +
            ' , tableKeyValue = ' + tableKeyValue + ' , msg = ' + msg);
        const modalRef = this.modalService.open(SearchItemIdDialogComponent, { size: 'lg', centered: true, backdrop: 'static' });

        modalRef.componentInstance.searchFilter = 3;

        modalRef.componentInstance.action = action;
        modalRef.componentInstance.status = status;
        modalRef.componentInstance.tableKeyValue = tableKeyValue;
        modalRef.componentInstance.msg = msg;

        // modalRef.componentInstance.displayMsg = this.getDisplayMsg(tableKeyValue);
        // modalRef.componentInstance.data = data;

        return modalRef;

    }

    openDialogWithSelectFilter(searchFilter: number) {
        this.log.d(TAG, 'openDialogWithSelectFilter searchFilter = ' + searchFilter);

        const modalRef = this.modalService.open(SearchItemIdDialogComponent, { size: 'lg', centered: true, backdrop: 'static' });

        modalRef.componentInstance.searchFilter = searchFilter;


        return modalRef;
    }


    openDialog_BillPay_ItemAndPackage_WithSelectFilter(searchFilter: number,positionCase:string ,isSelectItem:boolean, isSelectPackage:boolean) {
        this.log.d(TAG, 'openDialog_BillPay_ItemAndPackage_WithSelectFilter searchFilter = ' + searchFilter);

        const modalRef = this.modalService.open(BillPaymentSearchItemPackageDialogComponent, {  size: 'lg',centered: true, backdrop: 'static'
        });

        modalRef.componentInstance.searchFilter = searchFilter;
        modalRef.componentInstance.isShowItem = isSelectItem;
        modalRef.componentInstance.isSelectPackage = isSelectPackage;
        modalRef.componentInstance.positionCase = positionCase;


        return modalRef;
    }





    openGRNDialogWithSelectFilter(searchFilter: number) {
        this.log.d(TAG, 'openGRNDialogWithSelectFilter searchFilter = ' + searchFilter);

        const modalRef = this.modalService.open(SearchGRNMedDialogComponent, { size: 'lg', centered: true, backdrop: 'static' });

        modalRef.componentInstance.searchFilter = searchFilter;


        return modalRef;
    }


}





